import moment from "moment";
// import {round_to_precision} from '../helpers'
const getLastDateOfChosenMonth = chosen_month => {
	const start_date = new Date(chosen_month + "-01");
	const last_date = moment(start_date).endOf("month");
	const is_31 = new Date(last_date).getDate() == 31;
	return is_31 ? last_date.subtract(1, 'day') : last_date;
};
const handelElectricWaterPrice = arr => {
	let sorted_arr = arr.sort((a, b) => {
		let unix_a = moment(a.date_check).unix();
		let unix_b = moment(b.date_check).unix();
		if (unix_a < unix_b) return 1;
		if (unix_a > unix_b) return -1;
		return 0;
	});
	let end = sorted_arr[0] ? sorted_arr[0].count : 0;
	let start = sorted_arr[1] ? sorted_arr[1].count : 0;
	if (sorted_arr[0] && sorted_arr[0].check_in_id && start == 0){
		start = end
	}
	return { data: sorted_arr, start, end };
};
const handleDateCount = (date_start, chosen_month, date_end, is_room_date_count, date_schedule_end) => {
	const computed_date_end = date_end ? new Date(date_end) : new Date();
	const computed_date_schedule_end = date_schedule_end ? new Date(date_schedule_end) : ''
	const computed_date_start = new Date(date_start.substr(0, 10));
	const first_date_of_chosen_month = new Date(chosen_month + "-01");
	const last_date_of_chosen_month = new Date(
		getLastDateOfChosenMonth(chosen_month)
	);
	if (
		computed_date_end < first_date_of_chosen_month ||
		computed_date_start > last_date_of_chosen_month
	)
		return 0;
	if (computed_date_schedule_end && computed_date_end > moment(first_date_of_chosen_month).endOf("month") ){
		const days_of_current_month = computed_date_start > first_date_of_chosen_month ? computed_date_start.getDate() : 0
		return 30 - days_of_current_month + computed_date_schedule_end.getDate()
	}
	const new_date_end =
		last_date_of_chosen_month < computed_date_end
			? last_date_of_chosen_month
			: computed_date_end;
	const new_date_start =
		first_date_of_chosen_month > computed_date_start
			? first_date_of_chosen_month
			: computed_date_start;
	let diff = moment(new_date_end).diff(moment(new_date_start), "days");
	if (!diff) return 0;
	if (
		moment(new_date_start).diff(moment(first_date_of_chosen_month), "days") == 0 &&
		moment(new_date_end).diff(moment(last_date_of_chosen_month), "days") == 0
	) return 30;
	// is_room_date_count && (diff += 1)
	if (new_date_end - last_date_of_chosen_month != 0 || is_room_date_count) diff++
	if (last_date_of_chosen_month.getDate() < 30 && is_room_date_count) diff ++
	// diff += 1
	return diff < 30 || computed_date_schedule_end ? diff : 30;
};
// const handleDevicePrice = (arr, room, chosen_month, date_end) => {
// 	let parking_mortobike_bill = 0;
// 	let parking_bike_bill = 0;
// 	let washing_machine_bill = 0;
// 	let air_conditioner_bill = 0;
// 	let internet_bill = 0;
// 	let wm = null;
// 	let ac = null;
// 	let vh = [];
// 	let internet = null;
// 	arr.forEach(device => {
// 		device.date_count = handleDateCount(
// 			device.date_start,
// 			chosen_month,
// 			date_end
// 		);
// 		if (device.type === "MB") {
// 			vh.push(device);
// 			device.bill = (room.motorbike_price / 30) * device.date_count;
// 			parking_mortobike_bill += device.bill;
// 		} else if (device.type === "B") {
// 			vh.push(device);
// 			device.bill = (room.bike_price / 30) * device.date_count;
// 			parking_bike_bill += device.bill;
// 		} else if (device.type === "WM") {
// 			wm = device;
// 			device.bill = room.washing_machine_price
// 				? (room.washing_machine_price / 30) * device.date_count
// 				: 0;
// 			washing_machine_bill += device.bill;
// 		} else if (device.type === "AC") {
// 			ac = device;
// 			device.bill = room.air_conditioner_price
// 				? (room.air_conditioner_price / 30) * device.date_count
// 				: 0;
// 			air_conditioner_bill += device.bill;
// 		} else if (device.type === "INTERNET") {
// 			internet = device;
// 			device.bill = room.air_conditioner_price
// 				? (room.air_conditioner_price / 30) * device.date_count
// 				: 0;
// 			air_conditioner_bill += device.bill;
// 		}
// 	});
// 	return {
// 		parking_mortobike_bill,
// 		parking_bike_bill,
// 		washing_machine_bill,
// 		air_conditioner_bill,
// 		wm,
// 		ac,
// 		vh
// 	};
// };
const handleDevice = (arr, price = 0, chosen_month, date_end) => {
	const data = [];
	let total_bill = 0;
	arr.forEach(device => {
		device.date_count = handleDateCount(
			device.date_start,
			chosen_month,
			device.is_valid ? date_end : device.date_end
		);
		if (device.type === "INTERNET" || device.type == "AC") {
			price = device.price || price;
		}
		if (device.date_count) {
			data.push(device);
			device.bill = Math.round((price / 30) * device.date_count);
			total_bill += device.bill;
		}
	});
	return { data, total_bill };
};

const findDateRangeCollapse = (date_range_1, date_range_2) => {
	if (
		date_range_1.end < date_range_2.start ||
		date_range_2.end < date_range_1.start
	)
		return 0;
	const end =
		date_range_1.end < date_range_2.end
			? date_range_1.end
			: date_range_2.end;
	const start =
		date_range_1.start > date_range_2.start
			? date_range_1.start
			: date_range_2.start;
	return { end, start };
};

const handleDateCountV2 = (
	date_range_1,
	date_range_2,
	chosen_month,
	date_end
) => {
	const end_range = new Date(date_end)
	const last_date_of_chosen_month = new Date(
		getLastDateOfChosenMonth(chosen_month)
	);
	const month = {
		start: new Date(chosen_month + "-01"),
		end: end_range
	};
	date_range_1.end = date_range_1.end ? date_range_1.end : month.end;
	date_range_2.end = date_range_2.end ? date_range_2.end : month.end;
	const date_range_1_chosen_month = findDateRangeCollapse(
		date_range_1,
		month
	);
	const date_range_2_chosen_month = findDateRangeCollapse(
		date_range_2,
		month
	);
	if (date_range_1_chosen_month && date_range_2_chosen_month) {
		const final_range = findDateRangeCollapse(
			date_range_1_chosen_month,
			date_range_2_chosen_month
		);
		if (final_range) {
			const diff = moment(final_range.end).diff(
				moment(final_range.start),
				"days"
			);
			if (final_range.start - month.start == 0 && moment(final_range.end).diff(moment(last_date_of_chosen_month), "days") == 0) return 30
			return final_range.start - month.start == 0 &&
				date_range_1.start - month.start != 0 &&
				date_range_2.start - month.start != 0
				? diff + 1
				: diff;
		}
	}
	return 0;
};
const handleWashingMachine = (
	washing_machines,
	price,
	customers,
	chosen_month,
	date_end
) => {
	const data = [];
	let total_bill = 0;
	washing_machines.forEach(wash => {
		customers.forEach(cus => {
			const date_range_1 = {
				start: wash.date_start
					? new Date(wash.date_start.substr(0, 10))
					: new Date(),
				end: wash.date_end ? new Date(wash.date_end) : ""
			};
			const date_range_2 = {
				start: cus.date_in
					? new Date(cus.date_in.substr(0, 10))
					: new Date(),
				end: cus.date_out ? new Date(cus.date_out) : ""
			};
			let date_count = handleDateCountV2(
				date_range_1,
				date_range_2,
				chosen_month,
				date_end
			);
			date_count = date_count > 30 ? 30 : date_count;
			const bill = (price / 30) * date_count;
			total_bill += bill;
			data.push({
				...cus,
				date_count,
				bill,
				price,
				washing_machine: wash
			});
		});
	});
	total_bill = Math.round(total_bill);
	return { data, total_bill };
};
// const roundMoney = (price) => {
//     let
//     return round_to_precision
// };
const calculateWaterPrice = (start, end, price) => {
	const diff = end - start;
	if (price > 10000) {
		return price * diff;
	} else {
		return diff > 8 ? 8 * 10000 + (diff - 8) * 15000 : diff * 10000;
	}
};

const calculateRoomBill = (room, chosen_month, date_end, date_schedule_end) => {
	// console.log(room.room_id);
	// Xử lý phòng
	const date_start =
		room.date_in > room.date_schedule_in
			? room.date_schedule_in
			: room.date_in;
	
	room.date_count = handleDateCount(date_start, chosen_month, date_schedule_end ? date_schedule_end : date_end, true, date_schedule_end);

	room.service_date_count = handleDateCount(date_start, chosen_month, date_end);

	room.room_bill = Math.round((room.room_price / 30) * room.date_count);
	room.trash_bill = Math.round((room.trash_price / 30) * room.service_date_count);
	// Xử lý diện
	room.electric = handelElectricWaterPrice(room.electric);
	room.electric.total_bill = Math.round
		((room.electric.end - room.electric.start) * room.electric_price);

	// Xử lý nước
	room.water = handelElectricWaterPrice(room.water);
	room.water.total_bill = calculateWaterPrice(
		room.water.start,
		room.water.end,
		room.water_price
	);
	// Xử lý device
	// let device_data = handleDevicePrice(room.deviceInfo, room, chosen_month, date_end)
	// Xủ lý Internet
	room.internet = handleDevice(room.internet, 0, chosen_month, date_end);
	// room.washing_machine = handleDevice(
	// 	room.washing_machine,
	// 	room.washing_machine_price * room.customer_count,
	// 	chosen_month,
	// 	date_end
	// );
	room.washing_machine = handleWashingMachine(
		room.washing_machine,
		room.washing_machine_price,
		room.customers,
		chosen_month,
		date_end
	);
	room.air_conditioner = handleDevice(
		room.air_conditioner,
		room.air_conditioner_price,
		chosen_month,
		date_end
	);
	room.bike = handleDevice(
		room.bike,
		room.bike_price,
		chosen_month,
		date_end
	);
	room.motorbike = handleDevice(
		room.motorbike,
		room.motorbike_price,
		chosen_month,
		date_end
	);
	if (room.is_included_air_conditioner) room.air_conditioner.total_bill = 0;
	room.total_bill =
		Math.round(
			(room.room_bill +
				room.electric.total_bill +
				room.water.total_bill +
				room.bike.total_bill +
				room.motorbike.total_bill +
				room.washing_machine.total_bill +
				room.air_conditioner.total_bill +
				room.internet.total_bill +
				room.trash_bill) /
				1000
		) * 1000;
	return room;
};
export { calculateRoomBill, getLastDateOfChosenMonth };
